import React from 'react';
import fetch from '../../../core/fetch';
import Layout from '../../../components/Layout';
import TermsOfService from './TermsOfService';
import { getEditStaticPage } from '../../../lib/graphql';

async function action({ }) {
    const resp = await fetch(`/graphql`, {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: getEditStaticPage,
            variables: { id: 6 }
        }),
        credentials: 'include',
    });

    const { data } = await resp.json();

    if (data?.getEditStaticPage) {
        return {
            title: data?.getEditStaticPage?.result?.metaTitle,
            description: data?.getEditStaticPage?.result?.metaDescription,
            component: <Layout><TermsOfService data={data} /></Layout>,
        };
    } else {
        return {
            title: 'Page Not Found',
            component: <Layout> <NotFound title={'Page Not Found'} /></Layout>,
        };
    }
}

export default action